import type { Installments } from '@/generated/graphql';
import { InstallmentType } from '@/types';

const getMaxInstallmentTermEnabledByMerchant = (
  installments: Array<Installments> = [],
): number => {
  const maxTermIndex = installments
    .map(installment => installment?.totalConsumerFee?.percentage === null)
    .lastIndexOf(true);
  return installments[maxTermIndex]?.term;
};

const getInstallmentType = (
  installments: Array<Installments> = [],
  maxTerm: number,
): InstallmentType | undefined => {
  if (!installments.length || !maxTerm || maxTerm <= 1) {
    return undefined;
  }
  const maxTermEnabledByMerchant: number =
    getMaxInstallmentTermEnabledByMerchant(installments);
  if (maxTerm === maxTermEnabledByMerchant) {
    return InstallmentType.MCI;
  }
  if (maxTermEnabledByMerchant <= 1) {
    return InstallmentType.FULL_IC2B;
  }
  return InstallmentType.SHARED_IC2B;
};

const getInstallmentTypeForSelectedTerm = (
  installments: Array<Installments> = [],
  selectedTerm: number,
): {
  installmentTypeSelected: string | undefined;
  installmentTypeShown: string | undefined;
} => {
  const installmentTypeShown: string | undefined = getInstallmentType(
    installments,
    installments?.[installments.length - 1]?.term,
  );
  let installmentTypeSelected = installmentTypeShown;
  if (installmentTypeShown === InstallmentType.SHARED_IC2B) {
    installmentTypeSelected =
      installments.filter(installment => installment.term === selectedTerm)?.[0]
        ?.totalConsumerFee?.percentage === null
        ? InstallmentType.MCI
        : InstallmentType.SHARED_IC2B;
  }
  return { installmentTypeSelected, installmentTypeShown };
};

const formatFraction = (value: string): string => {
  const num = parseFloat(value);
  if (isNaN(num)) {
    return '';
  }
  return Number.isInteger(num) ? num.toString() : num.toFixed(2);
};

export {
  formatFraction,
  getInstallmentType,
  getInstallmentTypeForSelectedTerm,
};
